import { render, staticRenderFns } from "./BrandProducts.vue?vue&type=template&id=2e072fec&"
import script from "./BrandProducts.vue?vue&type=script&lang=ts&"
export * from "./BrandProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports